import { render, staticRenderFns } from "./OnlyOfficeFullEditor.vue?vue&type=template&id=5f9ee53c&"
import script from "./OnlyOfficeFullEditor.vue?vue&type=script&lang=js&"
export * from "./OnlyOfficeFullEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports